import React from "react";
import { ShieldCheck, FileText, BadgeCheck, Star, Clock } from "lucide-react";
import { TRUST_ITEMS } from "@/data/site";

const ICONS = [ShieldCheck, FileText, BadgeCheck, Star, Clock, ShieldCheck];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      style={{
        background: "var(--ink)",
        borderTop: "1px solid var(--line)",
        borderBottom: "1px solid var(--line)",
        padding: "20px 0",
      }}
    >
      <div
        className="site-container"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 16,
          alignItems: "center",
        }}
      >
        {TRUST_ITEMS.slice(0, 5).map((label, i) => {
          const Icon = ICONS[i] || ShieldCheck;
          return (
            <div
              key={label}
              data-testid={`trust-item-${i}`}
              style={{
                display: "flex", alignItems: "center", gap: 10,
                fontSize: 12, color: "var(--text-mid)",
                letterSpacing: "0.005em",
              }}
            >
              <Icon size={15} strokeWidth={1.6} color="var(--gold)" />
              {label}
            </div>
          );
        })}
      </div>
    </section>
  );
}
